export default "__VITE_ASSET__DTvrVmYR__"